import * as d3 from 'd3'

export default {

  methods: {

    draw_Table() {
      let box = this.table.box
      let header = this.table.header
      let val = this.table.value

      let Table = this.canvasForms
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)

      this.columns.forEach((d,i)=> {

        Table
        .append('rect')
        .attr('x', d.sx).attr('y', 0)
        .attr('width', d.width).attr('height', box.height)
        .attr('fill', box.fColor)
        .attr('stroke', box.sColor).attr('stroke-width', box.stroke)
        .attr('opacity', box.opacity)
        .attr('rx', box.radius).attr('ry', box.radius)
        
        // Header
        Table
        .append('text')
        .attr('x', d.mx).attr('y', header.y + header.tSize*0.4)
        .attr('fill', header.tColor).attr('font-size', header.tSize)
        .attr('text-anchor', 'middle')
        .attr('font-family', 'roboto')
        .text(d.name)

        // Value
        Table
        .append('text')
        .attr('id', `VAL_${this.localId}_${i}`)
        .attr('x', d.tx).attr('y', val.y + d.tSize*0.4)
        .attr('fill', d.tColor).attr('font-size', d.tSize)
        .attr('text-anchor', d.align)
        .attr('font-family', 'roboto')
        .text(this.gmx_numFormat(this.rawData[d.code], d.unit))
        .call(this.event_Link, d)
      }) 
    },

  } 
}